var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPapersPile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4011_1956)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6849 11.5144C14.8537 11.8927 14.6839 12.3362 14.3056 12.5049L8.29894 15.1849C7.92067 15.3537 7.4772 15.1839 7.30843 14.8056C7.13966 14.4273 7.30949 13.9839 7.68776 13.8151L13.6944 11.1351C14.0727 10.9663 14.5162 11.1361 14.6849 11.5144Z",
    className: "icon-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.31552 11.5139C1.48461 11.1357 1.92821 10.9663 2.30634 11.1353L8.29968 13.8153C8.67781 13.9844 8.84727 14.428 8.67819 14.8062C8.5091 15.1843 8.06549 15.3538 7.68736 15.1847L1.69403 12.5047C1.3159 12.3356 1.14643 11.892 1.31552 11.5139Z",
    className: "icon-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6849 8.19435C14.8537 8.57262 14.6839 9.01609 14.3056 9.18486L8.29894 11.8649C7.92067 12.0336 7.4772 11.8638 7.30843 11.4855C7.13966 11.1073 7.30949 10.6638 7.68776 10.495L13.6944 7.81502C14.0727 7.64625 14.5162 7.81608 14.6849 8.19435Z",
    className: "icon-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.31552 8.19378C1.48461 7.81565 1.92821 7.64619 2.30634 7.81528L8.29968 10.4953C8.67781 10.6644 8.84727 11.108 8.67819 11.4861C8.5091 11.8642 8.06549 12.0337 7.68736 11.8646L1.69403 9.18461C1.3159 9.01552 1.14643 8.57192 1.31552 8.19378Z",
    className: "icon-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.70291 1.81516C7.89775 1.72817 8.12042 1.72829 8.31516 1.81549L14.3065 4.49815C14.5764 4.61902 14.7501 4.88726 14.75 5.18304C14.7499 5.47881 14.5759 5.74688 14.3058 5.86748L8.29716 8.55082C8.10228 8.63784 7.87956 8.63772 7.68477 8.55049L1.69344 5.86715C1.4235 5.74626 1.24983 5.478 1.25 5.18223C1.25017 4.88645 1.42416 4.6184 1.69424 4.49782L7.70291 1.81516ZM3.83728 5.18374L7.99178 7.04441L12.1627 5.18176L8.00822 3.32155L3.83728 5.18374Z",
    className: "icon-fill"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4011_1956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPapersPile);
export default __webpack_public_path__ + "static/media/icon-papers-pile.d804d267f9e2c5669ebcd674f7b696b2.svg";
export { ForwardRef as ReactComponent };